import CommonMixin from './CommonMixin'
import OverviewLayout from './OverviewLayout'
import DetailField from './DetailField'
import Validation from '../validation'

export default {
  name: 'OverviewMixin',
  mixins: [CommonMixin],
  components: {
    OverviewLayout,
    DetailField
  },
  // props: {
  // },
  data () {
    return {
      searchRec: {},
      bulkRec: {}, // for Bulk Edit Modal
      boolFilterOptions: [{'text': '', 'value': ''}, {'text': 'yes', 'value': 'yes'}, {'text': 'no', 'value': 'no'}]
    }
  },
  computed: {
    // table () {
    //   console.log('OverviewMixin.table', this)
    //   return this.$refs.overview.table
    // }
  },
  methods: {
    doFilter () {
      this.$refs.overview.setFilter(this.searchRec)
    },
    exportSelection (url, filename) {
      let filterParams = this.$refs.overview.getFilterParams(this.searchRec)
      this.api.downloadPost(url, filterParams, filename)
    },
    postWithSelection (url, errorMsg, successFnc) {
      let filterParams = this.$refs.overview.getFilterParams(this.searchRec)
      this.api.post(url, filterParams, data => {
        // console.log('post result ', url, filterParams, data, successFnc)
        if (successFnc) successFnc()
      },
      errorMsg, this.$refs.overview.$refs.alert)
    },
    hasSelections () { return this.$refs.overview ? this.$refs.overview.table.selectedTo.length : 0 },
    bulkOk (url, errorMsg = 'applying bulk edit', successFnc = null) {
      const selectedIds = this.$refs.overview.table.selectedTo
      const changes = Validation.getChangedFields(this.validator, this.bulkRec)
      if (Object.keys(changes).length === 0) return
      const rec = {'ids': selectedIds, 'changes': changes}
      this.api.post(url, rec, data => {
        if (successFnc) successFnc()
        this.$refs.overview.table.selectedTo = [] // clear the selected list
        this.$refs.overview.refreshTable()
      },
      errorMsg, this.$refs.overview.$refs.alert)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OverviewMixin.js